import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/index.css'
import './styles/portal.css'
import './styles/onboarding-form.css'

// NOTE: We intentionally do NOT block iOS `gesturestart/change/end` here.
// Two-finger pinch-zoom must work so users can zoom the PDF form on iPad.
// (The PDF canvas and its overlay inputs scale together under native pinch,
// so alignment is preserved.)

// Prevent only DOUBLE-TAP zoom on iOS, but never swallow taps on interactive
// elements (buttons, inputs, links) - preventDefault there suppresses the
// synthetic click, breaking Next/Submit and validation on mobile. Two-finger
// pinch is unaffected because this only fires on single-finger touchend.
let lastTouchEnd = 0;
document.addEventListener('touchend', (e) => {
  const now = Date.now();
  const isInteractive = e.target.closest?.('button, a, input, select, textarea, label, [role="button"]');
  if (now - lastTouchEnd <= 300 && !isInteractive) {
    e.preventDefault();
  }
  lastTouchEnd = now;
}, { passive: false });

// iOS Safari auto-zooms (and scroll-jumps) into any input/select/textarea whose
// font-size is under 16px. Our PDF overlay fields are intentionally small, so
// this fired on every field tap. We keep native pinch-zoom enabled, but while a
// field is focused we temporarily lock the viewport so iOS cannot focus-zoom;
// once the field blurs, we restore the zoomable viewport so pinch still works.
(() => {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;

  const ZOOMABLE = 'width=device-width, initial-scale=1.0, viewport-fit=cover';
  const LOCKED =
    'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';

  const isField = (el) =>
    el && el.matches?.('input, select, textarea');

  document.addEventListener('focusin', (e) => {
    if (isField(e.target)) viewport.setAttribute('content', LOCKED);
  });

  document.addEventListener('focusout', (e) => {
    if (isField(e.target)) viewport.setAttribute('content', ZOOMABLE);
  });
})();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
